import { useEffect } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { useHighlighted } from "contexts/highlighted";
import { useObjectTree } from "contexts/objectTree";
import { renderActions } from "features/render/renderSlice";
import { deriveTopLevelSelections } from "utils/treeHelpers";

/**
 * Reactively derives topLevelSelections from the current highlighted IDs and
 * the loaded object tree, dispatching the result to Redux on each change.
 *
 * Derivation is skipped when nothing is selected (idArr is empty), which covers
 * the common no-selection case cheaply. When the tree widget has never been
 * opened the tree stays as emptyModelTree and the derivation returns an empty
 * record, leaving useFlyToSelected to fall back to batchedPropertySearch.
 */
export function useTopLevelSelectionsSync() {
    const { ids } = useHighlighted();
    const tree = useObjectTree();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (ids.size === 0) {
            dispatch(renderActions.clearTopLevelSelections());
            return;
        }
        const derived = deriveTopLevelSelections(ids, tree);
        dispatch(renderActions.setTopLevelSelections(derived));
    }, [ids, tree, dispatch]);
}
